import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home/Home';
import NotFound from './Shared/NotFound';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SingleProject from './Pages/SingleProject';
import Navber from './Shared/Navber/Navber';
import Footer from './Shared/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import SignIn from './Pages/SignIn';
import SignUp from './Pages/SignUp';
import ResetPassword from './Pages/ResetPassword';
import Deshboard from './Pages/Deshboard/Deshboard';
import MyProfile from './Pages/Deshboard/MyProfile';
import AddProject from './Pages/Deshboard/AddProject';
import RequireAuth from './Shared/RequireAuth';
import AboutMeUpdate from './Pages/Deshboard/AboutMeUpdate';
import ManageProjects from './Pages/Deshboard/ManageProjects';
import AddServices from './Pages/Deshboard/AddServices';
import ManageService from './Pages/Deshboard/ManageService';



AOS.init();

function App() {
  return (
    <div>
      <Navber />
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/home' element={<Home />} ></Route>
        <Route path='/mother' element={<SignIn />}></Route>
        <Route path='/father' element={<SignUp />} ></Route>
        <Route path='/fmresetpassword' element={<ResetPassword />} ></Route>
        <Route path='/projects/:Id' element={<SingleProject />}></Route>
        <Route path='/secretdeshboard' element={<RequireAuth> <Deshboard /></RequireAuth>}>
          <Route index element={<RequireAuth> <MyProfile /> </RequireAuth>}></Route>
          <Route path='addproject' element={<RequireAuth> <AddProject /></RequireAuth>}></Route>
          <Route path='addservices' element={<RequireAuth> <AddServices /> </RequireAuth>}></Route>
          <Route path='secretaboutme' element={<RequireAuth>  <AboutMeUpdate /> </RequireAuth>}></Route>
          <Route path='secretmanageproject' element={<RequireAuth> <ManageProjects /> </RequireAuth>}></Route>
          <Route path='secretmanageservice' element={<RequireAuth> <ManageService />  </RequireAuth>}></Route>
        </Route>
        <Route path='*' element={<NotFound />} ></Route>
      </Routes>
      <Footer />
      <MessengerCustomerChat
        pageId="109059241525933"
        appId="1050332159230593"
      >
      </MessengerCustomerChat>
      <ToastContainer />
    </div>
  );
}

export default App;
